module.exports = __webpack_public_path__ + "media/images/icons/step-icon-gray-011492695689f8a346f3d6c789a860a5.svg";